import { getPageOrdersQuery } from '@redlink/services';

export const freshCacheForChangeStatus =
  ({ skip, take }) =>
  (cache, { data: { SetOrderStatus: { id, status } = {} } }) => {
    const {
      Orders: { totalCount, items: oldData },
    } = cache.readQuery({
      query: getPageOrdersQuery,
      variables: {
        skip,
        take,
      },
    });

    let freshData = { ...oldData.find((p) => p.id === id), status };

    cache.writeQuery({
      query: getPageOrdersQuery,
      data: {
        Orders: {
          totalCount,
          items: getFreshOrders({ id, oldData, freshData }),
        },
      },
      variables: {
        skip,
        take,
      },
    });
  };

export const freshCacheForChangeItemsStatus =
  ({ skip, take }) =>
  (
    cache,
    {
      data: {
        SetOrderItemsStatus: {
          orderId: id,
          status: newStatus,
          orderItemsIds,
        } = {},
      },
    }
  ) => {
    const {
      Orders: { totalCount, items: oldData },
    } = cache.readQuery({
      query: getPageOrdersQuery,
      variables: {
        skip,
        take,
      },
    });

    const existData = oldData.find((p) => p.id === id);
    let freshData = {
      ...existData,
      items: existData.items.map(({ status, product, ...rest }) => ({
        ...rest,
        product,
        status: orderItemsIds.some((p) => p === product.id)
          ? newStatus
          : status,
      })),
    };

    cache.writeQuery({
      query: getPageOrdersQuery,
      data: {
        Orders: {
          totalCount,
          items: getFreshOrders({ id, oldData, freshData }),
        },
      },
      variables: {
        skip,
        take,
      },
    });
  };

const getFreshOrders = ({ id, oldData, freshData }) => {
  const editedItemIndex = oldData.findIndex((p) => p.id === id);
  return [
    ...oldData.slice(0, editedItemIndex),
    freshData,
    ...oldData.slice(editedItemIndex + 1),
  ];
};
